import React, { useState } from "react";
import BreadCrumb from "../../../Common/BreadCrumb";

const EdiTable = () => {
  const [items, setItems] = useState([
    {
      id: 1,
      name: "Lindsay Walton",
      title: "Front-end Developer",
      phone: "832-333-0011",
      role: "Admin",
      editing: false,
    },
    {
      id: 2,
      name: "Courtney Henry",
      title: "Designer",
      phone: "551-697-3625",
      role: "Owner",
      editing: false,
    },
    {
      id: 3,
      name: "Tom Cook",
      title: "Director of Product",
      phone: "208-628-0572",
      role: "Admin",
      editing: false,
    },
    {
      id: 4,
      name: "Whitney Francis",
      title: "Copywriter",
      phone: "903-342-3348",
      role: "Owner",
      editing: false,
    },
    {
      id: 5,
      name: "Leonard Krasner",
      title: "Senior Designer",
      phone: "602-690-7009",
      role: "Admin",
      editing: false,
    },
  ]);

  const handleDoubleClick = (item: any, field: any) => {
    setItems((prevItems) =>
      prevItems.map((prevItem) => {
        if (prevItem.id === item.id) {
          return { ...prevItem, editing: true };
        }
        return prevItem;
      })
    );
    setTimeout(() => {
      document.getElementById(field)?.focus();
    }, 0);
  };

  const handleEditFinish = (item: any) => {
    setItems((prevItems) =>
      prevItems.map((prevItem) => {
        if (prevItem.id === item.id) {
          return { ...prevItem, editing: false };
        }
        return prevItem;
      })
    );
  };

  const handleRemove = (itemId: any) => {
    setItems((prevItems) => prevItems.filter((item) => item.id !== itemId));
  };

  return (
    <React.Fragment>
      <BreadCrumb title="Editable" pageType="Table" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Table Editable
            </h2>
            <div className="overflow-auto">
              <span className="text-muted">Text Double Click To Edit Table.</span>
              <table className="min-w-[640px] w-full mt-4 table-hover">
                <thead>
                  <tr className="ltr:text-left rtl:text-right">
                    <th>#</th>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Phone No.</th>
                    <th>Role</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr
                      key={item.id}
                    >
                      <td>{item.id}</td>
                      <td>
                        <span
                          onDoubleClick={() => handleDoubleClick(item, "name")}
                          style={{ display: !item.editing ? "inline" : "none" }}
                        >
                          {item.name}
                        </span>
                        <input
                          type="text"
                          className="form-input"
                          ref={(ref) => ref && ref.id === "name" && ref.focus()}
                          value={item.name}
                          onChange={(e) =>
                            setItems((prevItems) =>
                              prevItems.map((prevItem) =>
                                prevItem.id === item.id
                                  ? { ...prevItem, name: e.target.value }
                                  : prevItem
                              )
                            )
                          }
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleEditFinish(item)
                          }
                          style={{ display: item.editing ? "inline" : "none" }}
                        />
                      </td>
                      <td>
                        <span
                          onDoubleClick={() => handleDoubleClick(item, "title")}
                          style={{ display: !item.editing ? "inline" : "none" }}
                        >
                          {item.title}
                        </span>
                        <input
                          type="text"
                          className="form-input"
                          ref={(ref) =>
                            ref && ref.id === "title" && ref.focus()
                          }
                          value={item.title}
                          onChange={(e) =>
                            setItems((prevItems) =>
                              prevItems.map((prevItem) =>
                                prevItem.id === item.id
                                  ? { ...prevItem, title: e.target.value }
                                  : prevItem
                              )
                            )
                          }
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleEditFinish(item)
                          }
                          style={{ display: item.editing ? "inline" : "none" }}
                        />
                      </td>
                      <td>
                        <span
                          onDoubleClick={() => handleDoubleClick(item, "phone")}
                          style={{ display: !item.editing ? "inline" : "none" }}
                        >
                          {item.phone}
                        </span>
                        <input
                          type="text"
                          className="form-input"
                          ref={(ref) =>
                            ref && ref.id === "phone" && ref.focus()
                          }
                          value={item.phone}
                          onChange={(e) =>
                            setItems((prevItems) =>
                              prevItems.map((prevItem) =>
                                prevItem.id === item.id
                                  ? { ...prevItem, phone: e.target.value }
                                  : prevItem
                              )
                            )
                          }
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleEditFinish(item)
                          }
                          style={{ display: item.editing ? "inline" : "none" }}
                        />
                      </td>
                      <td>
                        <span
                          onDoubleClick={() => handleDoubleClick(item, "role")}
                          style={{ display: !item.editing ? "inline" : "none" }}
                        >
                          {item.role}
                        </span>
                        <select
                          className="form-select"
                          ref={(ref) => ref && ref.id === "role" && ref.focus()}
                          value={item.role}
                          onChange={(e) =>
                            setItems((prevItems) =>
                              prevItems.map((prevItem) =>
                                prevItem.id === item.id
                                  ? { ...prevItem, role: e.target.value }
                                  : prevItem
                              )
                            )
                          }
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleEditFinish(item)
                          }
                          style={{ display: item.editing ? "inline" : "none" }}
                        >
                          <option>Admin</option>
                          <option>Owner</option>
                        </select>
                      </td>
                      <td>
                        <button
                          className="text-danger ltr:ml-2 rtl:mr-2"
                          onClick={() => handleRemove(item.id)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            className="inline-block w-5 h-5"
                          >
                            <path
                              fill="currentColor"
                              d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"
                            ></path>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EdiTable;
